import axios from 'axios';

const apiUrl = process.env.REACT_APP_ALCATRAZ_FLIGHT_SERVICE;

const utilsApi = {
  /**
   * generate unique permalink
   * @param inputString
   * @returns {object} res - result object
   */
  generatePermalink: (inputString, token) => new Promise((resolve, reject) => {
    axios
      .post(
        `${apiUrl}/api/v1/utils/permalink`,
        { input: inputString },
        {
          headers: {
            'x-access-token': token,
          },
        },
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  }),

  /**
   * generate a provider permalink
   * @param {object} data - flight data to generate a provider permalink
   * @returns {object} res - result object
   */
  providerPermalink: (data, token) => new Promise((resolve, reject) => {
    axios
      .post(`${apiUrl}/api/v1/utils/provider-permalink`, data, {
        headers: {
          'x-access-token': token,
        },
      })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  }),
};

export default utilsApi;
